/**
 * RemoteItems
 * 
 * @Author: Focci
 * @Date: 2024-11-07 11:37:22
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-07 11:37:22
 */

import { useMapState } from '@comp/mapbox'
import { useCallback, useMemo } from 'react'
import { isAU, isNZ } from '@lib/utils'
import { isArray, forEach } from 'lodash-es'
import OverallItemScoff, { OverallItemSwitch } from '../OverallItemScoff'
import UnitaryHoverPopup from '../../UnitaryHoverPopup'

export default function RemoteItems({ options }) {
  const { layers, setLayers } = useMapState()

  const handleChange = useCallback((_, { value }) => {
    setLayers((prev) => {
      const tmp = prev.display.indexOf(value) > -1 ? [] : [value]
      return { ...prev, display: tmp }
    })
  }, [setLayers])

  const hoverLayers = useMemo(() => {
    const tmp = []
    forEach(layers.display, (key) => (
      forEach(
        isArray(layers.cfg?.[key]) ? layers.cfg[key] : [],
        (child) => child.legendColumn 
          && tmp.push({ prop: child.legendColumn, layer: child.layersConfig?.id })
      )
    ))
    return tmp
  }, [layers])

  return (
    <>
      {options.map((opt) => (
        <OverallItemScoff key={opt.value} title={opt.label} expanding>
          <div className="grid grid-cols-1 gap-2">
            {isArray(opt.children) && opt.children.map((child) => (
              <OverallItemSwitch
                key={child.value} 
                label={child.label}
                description={child.description}
                badge={child.badge}
                onChange={(e) => handleChange(e, child)}
                checked={layers.display?.indexOf(child.value) > -1}
              />
            ))}
          </div>
        </OverallItemScoff>
      ))}
      {/* NZ: 房产开发 */}
      {isNZ && layers.display.indexOf('unitaryPlanning') > -1 && <UnitaryHoverPopup />}
      {/* AU: 点击图层在地图上显示boundary和名称 */}
      {isAU && hoverLayers.length > 0 && (
        <UnitaryHoverPopup layers={hoverLayers} />
      )}
    </>
  )
}
